module.exports = __webpack_public_path__ + "static/media/insights-coming-soon.dd78837a.svg";